<template>
	<div id="top" style="padding-top: 72px">
		<head-nav @userInfo="getUserToken"></head-nav>
		<div class="domConversionOfd_body" :class="isPhone == 'true' ? 'mobile' : ''">
			<div class="title">
				<span>
					{{ pageTitle }}
					<span class="icon_free">限时免费</span>
				</span>
			</div>
			<div class="s_title">
				<p v-html="pageStitle" style="display: inline-block; margin: 0"></p>
				<a v-if="pageType != 'totxt' && pageType != 'ofdtopdf'" @click.prevent="anchor('ms')">更多</a>
				<!-- <el-tooltip
                    v-if="pageType != 'totxt' && pageType != 'ofdtopdf'"
                    placement="bottom-start"
                    effect="light">
                    <div slot="content">
                        {{contentTips}}
                        <p>更多格式请<a @click.prevent="anchor('aboutUs')">联系我们</a></p>
                        永中Office、普华Office、XPS、CEB、SEP、S2、S72、S92、PS2、S10
                    </div>
                    <i class="el-icon-info"></i>
				</el-tooltip>-->
			</div>
			<!-- <div class="down-type" v-if="!token">
				<div class="uploader-btn btn btn-primary"></div>
				<p>点击或拖拽打开文件，文件总大小不超过10M。</p>
			</div>-->
			<div class="down-type" :class="{ active: isShow }">
				<uploader
					ref="uploader"
					:options="options"
					:autoStart="false"
					@dragenter="dragenter"
					@file-added="onFileAdded"
					@files-submitted="onSubmitted"
					@file-progress="onFileProgress"
					class="uploader-app"
					v-if="!isShow"
				>
					<uploader-unsupport></uploader-unsupport>
					<uploader-drop>
					<div
						class="uploader-btn btn btn-primary"
						v-if="!token"
						@click.prevent="loginBtn"
					>选择文件</div>
					<uploader-btn
						id="global-uploader-btn"
						v-else
						class="uploader-btn btn btn-primary"
						:attrs="attrs"
						ref="uploadBtn"
					>选择文件</uploader-btn>
					<p>点击或拖拽打开文件，文件总大小不超过10M。</p>
					<!-- <div class="tips_box">
                        <div class="tips_upload">限时免费，开启OFD畅享体验</div>
					</div>-->
				</uploader-drop>
				</uploader>

				<dom-turn
					:isShowData="isShow"
					:fileListData="fileList"
					:attrsData="attrs.accept"
					:allUpLoadIngData="allUpLoadIng"
					:pageName="pageType"
					@endTurn="endTurn"
					@AddUpload="AddUpload"
					:isMergeTurnData="isMergeTurn"
					:allzhSuccessEndData="allzhSuccessEnd"
				></dom-turn>
			</div>
			<!--   转换描述   -->
			<div id="ms"></div>
			<conversion-des :pageName="pageType" @callUs="getCallUs"></conversion-des>
			<!-- 提示弹框 -->
			<el-dialog
				title="提示"
				:visible.sync="dialogFolder"
				class="changephone_box fail_box"
				:close-on-click-modal="false"
				width="420px"
				append-to-body
			>
				<div class="content">
					<h2>以下{{ gsErrorList.length + wkErrorList.length }}个文件添加失败！</h2>
					<div class="item_list" v-if="gsErrorList.length > 0">
						<h3>文件格式不匹配：</h3>
						<p v-for="(item, index) in gsErrorList" :key="index">
							<icon
								:type="1"
								:fileType="item.fileTypeCase"
								:isTable="true"
								:fileFail="false"
								:isSeach="true"
							></icon>
							<a
								:title="item.name + '.' + item.fileType"
							>{{ item.name.length > 15 ? item.slname : item.name }}{{ "." + item.fileType }}</a>
						</p>
					</div>
					<!-- <div class="item_list" v-if="cfErrorList.length > 0">
                        <h3>文件已存在：</h3>
                        <p v-for="(item, index) in cfErrorList" :key="index">
                        {{ item.name }}
                        </p>
					</div>-->
					<div class="item_list" v-if="wkErrorList.length > 0">
						<h3>文件大小为空：</h3>
						<p v-for="(item, index) in wkErrorList" :key="index">
							<img src="@comm/images/document-conversion/kong_icon.svg" />
							<a
								:title="item.name + '.' + item.fileType"
							>{{ item.name.length > 15 ? item.slname : item.name }}{{ "." + item.fileType }}</a>
						</p>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="submitFolder" size="mini">确 定</el-button>
				</div>
			</el-dialog>
		</div>
		<customer-service :callUs="callUs" @callUs="getCallUs"></customer-service>
		<!--    footer -->
		<footer-nav></footer-nav>
	</div>
</template>

<script>
import SparkMD5 from "spark-md5";
import domTurn from "@comm/components/document-conversion/domTurn";
import { ACCEPT_CONFIG } from "@comm/utils/acceptFileType.js";
import { queryFileUploadInfo, uploadBurstFile } from "@comm/api/document-conversion";
import footerNav from "@comm/components/document-conversion/footerPage";
import headNav from "@comm/components/document-conversion/headerPage";
import conversionDes from "@comm/components/document-conversion/conversionDes";
import icon from "@comm/components/document-conversion/iconImg";
import customerService from "@comm/components/document-conversion/customerService";
import { buriedPoint } from "@comm/utils/buryingPoint.js";
import { getToken } from "@comm/utils/auth";
import common from "@comm/utils/common";
export default {
metaInfo: {
    title: '数科OFD格式转换中心，支持OFD在线转换为PDF等多种格式',
    meta: [
      {
        name: 'keywords',
        content: 'OFD、PDF转换、OFD格式转换、OFD转换、OFD转换格式'
      },
      {
        name: 'description',
        content: '数科OFD在线格式转换中心，支持OFD文档转换成PDF、图片，以及PDF、Excel、Word、PPT等格式转换成OFD；支持文件批量转换、合并转换。'
      }
    ]
  },
	components: {
		domTurn,
		footerNav,
		conversionDes,
		icon,
		customerService,
		headNav
	},
	name: "index",
	data() {
		return {
			fileList: [],
			options: {
				target: "invoice-info/upload",
				chunkSize: "2048000",
				fileParameterName: "upfile",
				maxChunkRetries: 1,
				testChunks: false,
				allowDuplicateUploads: true,
				headers: {
					// Authorization: getToken(),
				},
				query() { }
			},
			attrs: {
				accept: ""
			},
			isShow: false,
			pageType: "",
			pageTitle: "",
			pageStitle: "",
			contentTips: "",
			upLoadType: 0,
			allUpLoadIng: false,
			turnCount: 0,
			newList: [],
			upTime: "",
			oldFileList: [],
			isDragenter: false,
			allzhSuccessEnd: false,
			dialogFolder: false,
			gsErrorList: [],
			cfErrorList: [],
			wkErrorList: [],
			isMergeTurn: false,
			MergeData: null,
			isPhone: false,
			uploadList: [],
			uploadListLength: 0,
			callUs: false,
			token:null
		};
	},
	created() {
	},
	mounted() {
		this.turnCount = localStorage.turnCount ? localStorage.turnCount : 0;
		
		let path = this.$route.query.type;
		if (path) {
			this.pageType = path;
		} else {
			this.pageType = "toofd";
		}
		if (this.pageType == "toofd") {
			this.pageTitle = "其他转OFD";
			this.pageStitle = "<p>支持将<span style='display:inline-block;width:8px'></span>PDF、WPS、Word、Excel、PPT、TXT转换为OFD</p>";
			this.contentTips = "支持的格式：DOC/DOCX、XLS/XLSX、PPT/PPTX、WPS、PDF、TXT。";
			this.attrs.accept = ACCEPT_CONFIG.getAll();
			this.upLoadType = 1;
		} else if (this.pageType == "ofdtopdf") {
			this.pageTitle = "OFD转PDF";
			this.pageStitle = "<p>支持将<span style='display:inline-block;width:8px'></span>OFD文件转换为PDF</p>";
			this.contentTips = "";
			this.attrs.accept = ACCEPT_CONFIG.getOfd();
			this.upLoadType = 2;
		} else if (this.pageType == "topdf") {
			this.pageTitle = "其他转PDF";
			this.pageStitle = "<p>支持将<span style='display:inline-block;width:8px'></span>OFD、WPS、Word、Excel、PPT、TXT转换为PDF</p>";
			this.contentTips = "支持的格式：DOC/DOCX、XLS/XLSX、PPT/PPTX、WPS、OFD、CEB、SEP、TXT。";
			this.attrs.accept = ACCEPT_CONFIG.getFp();
			this.upLoadType = 5;
		} else if (this.pageType == "totxt") {
			this.pageTitle = "OFD转TXT";
			this.pageStitle = "<p>支持将<span style='display:inline-block;width:8px'></span>OFD文档转换为TXT格式文档</p>";
			this.contentTips = "";
			this.attrs.accept = ACCEPT_CONFIG.getOfd();
			this.upLoadType = 4;
		}
		this.token=getToken()
		this.isPhone = localStorage.getItem("isPhone");
		let toElement = document.getElementById("top");
		//锚点存在跳转
		toElement.scrollIntoView() + 100;
		document.body.ondrop = function(event){
			event.preventDefault();
			event.stopPropagation();
		}
		
	},
	watch: {
		$route(to, from) {
			this.$router.go(0);
		},
		progress() {
			this.$refs.uploader.uploader && this.$refs.uploader.uploader.progress();
		},
		uploadList(val) {
			if (val.length > 0 && this.allUpLoadIng) {
				for (let index = 0; index < val.length; index++) {
					if (index <= 4) {
						this.uploadApi(index);
					}
				}
			}
		},
		uploadListLength(val) {
			if (this.uploadListLength + 5 <= this.uploadList.length) {
				this.uploadApi(this.uploadListLength + 4);
			}
		}
	},

	methods: {
		getUserToken(data){
			this.token=data.token
		},
		getCallUs(data) {
			this.callUs = data;
		},
		/*锚链接跳转*/
		anchor(anchorName) {
			/*找到锚点*/
			let anchorElement = document.getElementById(anchorName);
			/*如果对应id的锚点存在，就跳转到锚点*/
			if (anchorElement) {
				anchorElement.scrollIntoView();
			}
		},
		endTurn(data) {
			this.isShow = data.isShow;
			this.fileList = data.fileList;
			this.oldFileList = data.oldFileList ? data.oldFileList : this.oldFileList;
			this.isMergeTurn = data.isMergeTurn;
			this.MergeData = data.MergeData;
			if (data.isAllDel) {
				if(this.$refs.uploader){
          this.$refs.uploader.uploader.cancel();
        }
			}
		},
		AddUpload(data) {
			this.oldFileList = data.fileList;
			this.MergeData = data.MergeData;
			this.isMergeTurn = data.isMergeTurn;
			this.allzhSuccessEnd = data.allzhSuccessEnd;
		},
		dragenter() {
			this.isDragenter = true;
		},
		submitFolder() {
			this.dialogFolder = false;
			// if(if){
			//      this.allUpLoadIng=false
			//    }
			setTimeout(function () {
				this.gsErrorList = [];
				// this.cfErrorList = [];
				this.wkErrorList = [];
			}, 300);
		},
		loginBtn() {
			let path = `${this.$route.path}?type=${this.$route.query.type}`;
			window.open(
				`https://openapi.wps.cn/oauthapi/v2/authorize?response_type=code&appid=AK20211015RYLLFO&autologin=false&redirect_uri=${common.readCodeUrl}${path}&scope=user_info&state=STATE`,
				"_self"
			);
		},
		onFileAdded(file, isReUpload, fileList) {
			this.allUpLoadIng = true;
			// this.isMergeTurn = false;
			if (this.pageType == "toimg" || this.pageType == "imgtoofd") {
				return;
			}
			this.gsErrorList = [];
			// this.cfErrorList = [];
			this.wkErrorList = [];

			file.progress = 0;
			file.disable = true;
			file.wait = true;
			if (isReUpload) {
				this.fileList = fileList;
				this.uploadApi(file.index, isReUpload);
			}
		},
		onSubmitted(fileList) {
			this.uploadList = [];
			this.uploadListLength = 0;
			// if (this.turnCount >= 5) {
			//   this.$refs.uploader.uploader.cancel();
			//   this.$confirm("今日转换次数已达上限5次", "", {
			//     confirmButtonText: "确定",
			//     showCancelButton: false,
			//     type: "warning",
			//   }).then(() => {
			//     return;
			//   });
			//   return;
			// }
			if (fileList.length <= 0) {
				return;
			}

			let dictionaryId = 0;
			if (this.pageType == "toofd") {
				dictionaryId = 70;
			} else if (this.pageType == "ofdtopdf") {
				dictionaryId = 92;
			} else if (this.pageType == "topdf") {
				dictionaryId = 107;
			} else if (this.pageType == "totxt") {
				dictionaryId = 116;
			}
			let clickType = this.isDragenter ? 1 : 0;
			this.isDragenter = false;
			setTimeout(function () {
				buriedPoint("isUpload", dictionaryId, clickType);
			}, 200);
			let sizeTotal = 0;
			let totalFileList = [];
			let oldZh = [];
			this.oldFileList.forEach((item) => {
				if (item.zhSuccess) {
					oldZh.push(item);
				}
			});
			if (oldZh.length > 0) {
				totalFileList = [...fileList];
			} else {
				totalFileList = [...this.oldFileList, ...fileList];
			}

			totalFileList.forEach((item) => {
				sizeTotal += +item.size;
			});

			const isLt = sizeTotal / 1024 / 1024 / 10 <= 1;
			if (!isLt) {
				if (this.MergeData) {
					this.isMergeTurn = true;
					this.allzhSuccessEnd = true;
				} else {
					this.isMergeTurn = false;
				}
				this.allUpLoadIng = false;
				this.$confirm("您选择的文件总大小超过10M，请重新选择！", "", {
					cancelButtonText: "取消",
					confirmButtonText: "确定",
					showCancelButton: false,
					type: "warning",
					showClose: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					lockScroll: false
				}).then(() => {
					this.allUpLoadIng = false;
					// this.fileList=this.oldFileList
					// this.$refs.uploader.uploader.cancel();
					return;
				});
			} else {
				this.isMergeTurn = false;
				let index = 0;
				this.infoDetails(index, fileList);
			}
		},
		infoDetails(index, fileList) {
			let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
			let fileReader = new FileReader();
			let spark = new SparkMD5.ArrayBuffer();
			fileReader.readAsArrayBuffer(blobSlice.call(fileList[index].file, 0, fileList[index].size));
			// 开始读取文件内容
			// reader.readAsDataURL(fileList[index].file);
			// 读取操作结束时触发
			fileReader.onload = (e) => {
				fileList[index].fileHash = this.$sha256(e.target.result);
				spark.append(e.target.result);
				fileList[index].baseUrl = spark.end();
				if (index == fileList.length - 1) {
					let lng = 0;
					let okList = [];
					this.newList = [];
					fileList.forEach((item, indexs) => {
						this.newList.push(item);
						if (indexs == fileList.length - 1) {
							this.dealData(lng, okList, fileList);
						}
					});
				} else {
					index = index + 1;
					this.infoDetails(index, fileList);
				}
			};
		},
		dealData(lng, okList, fileList) {
			let file = this.newList[lng];
			let extName = "";
			let AllUpExt = "";
			if (this.pageType == "toofd") {
				AllUpExt = ".pdf|.txt|.doc|.docx|.xls|.xlsx|.ppt|.pptx|.wps|";
			} else if (this.pageType == "topdf") {
				AllUpExt = ".ofd|.txt|.doc|.docx|.xls|.xlsx|.ppt|.pptx|.wps|";
			} else if (this.pageType == "ofdtopdf" || this.pageType == "totxt") {
				AllUpExt = ".ofd|";
			}
			extName = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
			if (AllUpExt.indexOf(extName + "|") == "-1") {
				file.cancel();
				var index = file.name.lastIndexOf(".");
				file.fileType = file.name.substring(index + 1, file.name.length);
				file.fileTypeCase = file.fileType.toLowerCase();
				file.name = file.name.substring(0, index);
				let fileListArrayname = file.name;
				let fileNameSuffix1 = fileListArrayname;
				if (fileListArrayname.length > 15) {
					file.slname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
				}
				this.gsErrorList.push(file);
				// if(lng==fileList.length-1){
				//   this.allUpLoadIng = false;
				// }
				fileList.splice(lng, 1);
			} else if (file.size == 0) {
				file.cancel();
				var index = file.name.lastIndexOf(".");
				file.fileType = file.name.substring(index + 1, file.name.length);
				file.fileTypeCase = file.fileType.toLowerCase();
				file.name = file.name.substring(0, index);
				let fileListArrayname = file.name;
				let fileNameSuffix1 = fileListArrayname;
				if (fileListArrayname.length > 15) {
					file.slname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
				}
				this.wkErrorList.push(file);
				//         if(lng==fileList.length-1){
				//   this.allUpLoadIng = false;
				// }
				fileList.splice(lng, 1);
			} else {
				if (this.oldFileList.length > 0) {
					let nameLng = 1;
					let isReturn = false;

					for (var jj = 0; jj < this.oldFileList.length; jj++) {
						var list = this.oldFileList[jj];
						if (file.baseUrl == list.baseUrl && file.name == list.name + "." + list.fileType) {
							// this.$refs.uploader.uploader.cancel();
							isReturn = true;
							file.cancel();
							this.cfErrorList.push(file);

							fileList.splice(lng, 1);
							// if(lng==fileList.length){
							//   this.allUpLoadIng = false;
							// }
							// this.allUpLoadIng = false;
						} else if (file.name == list.name + "." + list.fileType && file.baseUrl != list.baseUrl) {
							let index = file.name.lastIndexOf(".");
							let fileNameSuffix = file.name.substring(0, index);
							let fileType = file.name.substring(index, file.name.length);
							var fileNameTmp = file.name.substring(0, index) + "(" + nameLng + ")";
							for (var i = 0; i < this.oldFileList.length; i++) {
								if (fileNameTmp == this.oldFileList[i].name) {
									fileNameTmp = fileNameSuffix + "(" + ++nameLng + ")";
									i = 0;
								}
							}
							file.name = fileNameTmp + fileType;
							okList.push(file);
							break;
						} else {
							if (this.oldFileList.length - 1 == jj && !isReturn) {
								okList.push(file);
								break;
							}
						}
					}

					// this.oldFileList.forEach((list) => {
					// });
				} else {
					okList.push(file);
				}
			}
			if (lng != this.newList.length - 1) {
				lng = lng + 1;
				this.dealData(lng, okList, fileList);
			} else {
				if (this.gsErrorList.length > 0 || this.wkErrorList.length > 0) {
					if (this.MergeData) {
						this.isMergeTurn = true;
						this.allzhSuccessEnd = true;
					} else {
						this.isMergeTurn = false;
					}
					this.dialogFolder = true;
				}
				if (okList.length <= 0) {
					this.allUpLoadIng = false;
					return;
				}
				this.isShow = true;
				okList.forEach((item) => {
					item.isUpLoading = true;
					item.wait = true;
					var index = item.name.lastIndexOf(".");
					item.fileType = item.name.substring(index + 1, item.name.length);
					item.fileTypeCase = item.fileType.toLowerCase();
					item.name = item.name.substring(0, index);
				});
				this.fileList = okList;
				this.fileList.forEach((item) => {
					this.uploadList.push(item);
				});
			}
		},
		uploadApi(i, isReUpload) {
			let fileData = new FormData();
			fileData.append("multipartFile ", this.fileList[i].file);
			let dictionaryId = 0;
			if (this.pageType == "toofd") {
				dictionaryId = 71;
			} else if (this.pageType == "ofdtopdf") {
				dictionaryId = 93;
			} else if (this.pageType == "topdf") {
				dictionaryId = 108;
			} else if (this.pageType == "totxt") {
				dictionaryId = 117;
			}
			fileData.append("dictionaryId  ", dictionaryId);
			fileData.append("type", this.upLoadType);
			fileData.append("fileName  ", this.fileList[i].name + "." + this.fileList[i].fileType);
			fileData.append("fileHash", this.fileList[i].fileHash);
			this.fileList[i].wait = false;
			queryFileUploadInfo({
				dictionaryId: 0,
				fileHash: this.fileList[i].fileHash,
				fileName: this.fileList[i].name + "." + this.fileList[i].fileType
			})
				.then((res) => {
					if (!res.data.fileConversionNeedDTO) {
						this.apiUpLoad(i, fileData, isReUpload);
					} else {
						this.uploadListLength = this.uploadListLength + 1;
						this.fileList[i].fileConversionNeedDTO = res.data.fileConversionNeedDTO;
						this.fileList[i].isUpLoading = false;
						this.fileList[i].upLoadSuccess = true;
						if (this.uploadListLength == this.uploadList.length || isReUpload) {
							this.allUpLoadIng = false;
						}
					}
				})
				.catch((err) => {
					this.apiUpLoad(i, fileData, isReUpload);
				});
		},
		apiUpLoad(i, fileData, isReUpload) {
			let that = this;
			uploadBurstFile(fileData)
				.then((res) => {
					if (!res.data.success) {
						this.uploadListLength = this.uploadListLength + 1;
						this.fileList[i].isUpLoading = false;
						this.fileList[i].cause = res.data.cause;
						if (this.uploadListLength == that.uploadList.length || isReUpload) {
							this.allUpLoadIng = false;

							return;
						}
					} else {
						this.uploadListLength = this.uploadListLength + 1;
						this.fileList[i].isUpLoading = false;
						this.fileList[i].fileConversionNeedDTO = res.data.fileConversionNeedDTO;
						this.fileList[i].upLoadSuccess = true;
						if (this.uploadListLength == this.uploadList.length || isReUpload) {
							this.allUpLoadIng = false;
							return;
						}
					}
				})
				.catch((err) => {
					this.uploadListLength = this.uploadListLength + 1;
					this.fileList[i].isUpLoading = false;
					this.fileList[i].cause = "上传失败";
					if (this.uploadListLength == that.uploadList.length || isReUpload) {
						this.allUpLoadIng = false;

						return;
					}
				});
		},
		onFileProgress() { }
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#top {
	background: #fff url(../../comm/images/document-conversion/bj.png) no-repeat
		top / 100% auto;
	// background-size: 100% auto;
}
</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/domConversionOfd.vue